import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    companyInfo: {},
    navInfo: [],
  },
  getters: {

  },
  mutations: {
    // 设置公司信息
    setCompanyInfo(state , data) {
      state.companyInfo = data;
    },
    // 设置导航信息
    setNavInfo(state , data) {
      state.navInfo = data;
    },
  },
  actions: {

  },
});
